// Setup CSRF token for all Ajax requests
$.ajaxSetup({
  beforeSend: function(xhr, settings) {
    if (!settings.crossDomain && settings.type !== 'GET') {
      var token = $('meta[name="csrf-token"]').attr('content');
      if (token) {
        xhr.setRequestHeader('X-CSRF-Token', token);
      }
    }
  }
});

document.addEventListener('turbo:load', function() {
  var $body = $("body");
  var controller = $body.data("controller").replace(/\//, "_");
  var action = $body.data("action");

  /*
  var activeController = myApplication[controller];
  if (activeController !== undefined) {
    if ($.isFunction(activeController[action])) {
      activeController[action]();
    }
  }
  */

  if (controller.match(/^manage_/) && action === 'index') {
    if (location.hash === '#new') {
      $('#add-new-btn').get(0).click();
    }
    $('.search-clear').on('click', function(){
      $('#search-query').val('');
      $('#search-query-users-any').val('');
      $('#search-query-users-organization').val('');
    });
  }
  if (controller.match(/^manage_(?:emails|users)$/) && action === 'index') {
    $('.search-clear').on('click', function(){
      $('#search-group-id').val('');
    });
    $('#search-group-id').on('change', function(){
      $('.search-do').get(0).click();
    });
    $('#pickup-all').on('click', function(){
      $('.pickuped-users').prop('checked', $(this).prop('checked'));
    });
  }
  if (controller.match(/^(?:group_|general_)?articles$/) && action === 'update') {
    $(window).scrollTo('#error-explanation');
  }
});
